import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import useCheckboxes from "../../Hooks/useCheckboxes";
import PopulationService from "../../../Services/Population.service";
import useCurrentApiUser from "../../Hooks/useCurrentApiUser";
import { usePersonTypeInternalName } from "../../Hooks/usePersonType";
const PAGE_SIZE = 15;
const SEARCH_DEFAULT = "";
const DEFAULT_SEARCH = {
    search: SEARCH_DEFAULT,
};
const PersonPopulationLookup = ({ selected: selectedPopulations, children, }) => {
    var _a;
    const user = useCurrentApiUser();
    const personType = usePersonTypeInternalName();
    const [search, setSearch] = React.useState(SEARCH_DEFAULT);
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedPopulations || [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const searchItems = () => {
        setSearchArgs({
            search,
        });
    };
    const { table, dataState } = usePagedSortedTable({
        searchArgs,
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            getCheckedItem: (data, index) => data.data[index],
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No Filters found",
        initialSort: { sort: "name", order: "asc" },
        getData: (sort, page, sArgs) => {
            return PopulationService.search({
                query: sArgs.search,
                ownerIds: (user === null || user === void 0 ? void 0 : user.id) ? [user.id] : [],
                personTypeInternalNames: personType ? [personType] : undefined,
            }, {
                max: PAGE_SIZE,
                offset: page * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        columns: [
            {
                title: "Name",
                size: 2,
                sortId: "POPULATION_NAME",
            },
        ],
        rows: ({ data }) => data.map((population) => [population.name]),
    });
    return children({
        lookup: (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "populationSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "populationSearch", placeholder: "Search Name", style: { width: 200 }, value: search, onChange: (event) => {
                                        setSearch(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
    });
};
export default PersonPopulationLookup;
